'use client';

export const appCapabilities = {
  title: `Ask for a tool. Get a working app.`,
  line: `The spreadsheet your team keeps rebuilding, built once, on brand, and kept current.`,
  capabilities: [
    {
      key: `data`,
      label: `Keeps its data`,
      text: `Tables, boards and dashboards. Import a CSV and keep working.`,
    },
    {
      key: `decide`,
      label: `Records decisions`,
      text: `Approve, revise, hold or reject, with who decided and when.`,
    },
    {
      key: `fresh`,
      label: `Stays current`,
      text: `Refreshes on a schedule. IMAI reviews it daily and suggests updates you choose to apply.`,
    },
    {
      key: `yours`,
      label: `Yours to change`,
      text: `Pin it, share it with your team, and ask IMAI to change it when the work changes.`,
    },
  ],
  useCases: [
    {
      name: `Line plan`,
      ask: `Line planner for SS27 with margin by style`,
      who: `Merchandising`,
      real: !0,
    },
    {
      name: `Sample tracker`,
      ask: `Track every sample round from request to fit review`,
      who: `Development`,
      real: !1,
    },
    {
      name: `Fit review queue`,
      ask: `Fit review queue with photos and a verdict per style`,
      who: `Technical design`,
      real: !1,
    },
    {
      name: `Costing sheet`,
      ask: `Costing sheet with landed cost per style`,
      who: `Sourcing`,
      real: !1,
    },
    {
      name: `Supplier quotes`,
      ask: `Compare supplier quotes by MOQ, lead time and price`,
      who: `Sourcing`,
      real: !1,
    },
    {
      name: `Launch checklist`,
      ask: `Launch-week checklist by role for the SS27 drop`,
      who: `Marketing`,
      real: !1,
    },
    {
      name: `Content calendar`,
      ask: `Content calendar for the drop, by channel`,
      who: `Marketing`,
      real: !1,
    },
    {
      name: `Factory scorecard`,
      ask: `Scorecard for our factories: on-time, quality, cost`,
      who: `Production`,
      real: !1,
    },
  ],
};
